
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import ServicesGrid from './components/ServicesGrid';
import WhyUKBased from './components/WhyUKBased';
import WhoItsFor from './components/WhoItsFor';
import CTASection from './components/CTASection';

export default function SaudiRelocationPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.alwaz.travel';
    const scripts: HTMLScriptElement[] = [];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Saudi Arabia Relocation Services from UK | Alwaz Travels London',
        description: 'Planning to relocate to Saudi Arabia from the UK? Alwaz Travels offers expert relocation support including flights, temporary accommodation, family planning, and long-stay travel services.',
        url: `${siteUrl}/saudi-relocation`,
        isPartOf: { '@type': 'WebSite', name: 'Alwaz Travels', url: siteUrl },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Saudi Relocation', item: `${siteUrl}/saudi-relocation` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Saudi Arabia Relocation Services',
        provider: {
          '@type': 'TravelAgency',
          name: 'Alwaz Travels',
          url: siteUrl,
          telephone: '+442034884455',
          address: { '@type': 'PostalAddress', addressLocality: 'London', addressCountry: 'GB' },
        },
        description: 'Comprehensive UK-to-Saudi Arabia relocation support including flexible flights, temporary accommodation, family travel planning, and long-stay packages aligned with Vision 2030.',
        areaServed: [
          { '@type': 'Country', name: 'United Kingdom' },
          { '@type': 'Country', name: 'Saudi Arabia' },
        ],
        serviceType: 'Relocation Services',
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Saudi Relocation Services',
          itemListElement: [
            { '@type': 'Offer', name: 'Relocation Flight Packages', description: 'Flexible one-way and return flights for relocating professionals and families' },
            { '@type': 'Offer', name: 'Temporary Accommodation', description: 'Short-term serviced apartments and hotels in Riyadh, Jeddah, and Dammam' },
            { '@type': 'Offer', name: 'Family Relocation Planning', description: 'End-to-end family relocation support including school research and settling-in services' },
            { '@type': 'Offer', name: 'Long-Stay Travel Packages', description: 'Extended stay packages for professionals on Saudi Vision 2030 projects' },
          ],
        },
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Saudi Arabia Relocation Services from UK | Alwaz Travels London';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Planning to relocate to Saudi Arabia from the UK? Alwaz Travels offers expert relocation support including flights, temporary accommodation, family planning, and long-stay travel services aligned with Vision 2030.');

    return () => {
      scripts.forEach((s) => s.parentNode?.removeChild(s));
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <IntroSection />
      <ServicesGrid />
      <WhyUKBased />
      <WhoItsFor />
      <CTASection />
      <Footer />
    </div>
  );
}
